import React, { useState } from 'react';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import BicyclesSection from './components/Bicycles/BicyclesSection';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import './App.css';

const App = () => {
  const [activeSection, setActiveSection] = useState('home');

  const renderSection = () => {
    switch(activeSection) {
      case 'home':
        return <Home onSectionChange={setActiveSection} />;
      case 'bicycles':
        return <BicyclesSection />;
      case 'about':
        return <About />;
      case 'contact':
        return <Contact />;
      default:
        return <Home onSectionChange={setActiveSection} />;
    }
  };

  return (
    <div className="app">
      <Header activeSection={activeSection} onSectionChange={setActiveSection} />
      <main className="main-content">
        {renderSection()}
      </main>
    </div>
  );
};

export default App;